export const REPORT_METRICS_LOAD_REQUEST = "[REPORT_METRICS] REPORT_METRICS_LOAD_REQUEST";
export const REPORT_METRICS_LOAD_SUCCESS= "[REPORT_METRICS] REPORT_METRICS_LOAD_SUCCESS";

export const reportMetricsLoadRequest = () => ({type:REPORT_METRICS_LOAD_REQUEST});
export const reportMetricsLoadSuccess = reportMetrics => ({type:REPORT_METRICS_LOAD_SUCCESS,reportMetrics});